import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import IframeComponent from '../../components/IframeComponent';
import LoadingPage from '../../components/LoadingPage';
import { withLinkValidation } from '../../hoc/withLinkValidation';

function PercallIframe({ params }) {
  const [paymentUrl, setPaymentUrl] = useState('');
  const location = useLocation();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
  
    const environment = window.location.href.toLowerCase().includes('/qa/') ? 'qa' : 'prod';

  
    const query = params && typeof params.get === 'function'
      ? params
      : new URLSearchParams(location.search);

    const getParam = (key) => {
      try { return query.get(key); } catch { return null; }
    };

    const streamId   = getParam('streamId');
    const commandId  = getParam('commandId');
    const customerId = getParam('customerId');
    const rawAmount  = getParam('amount');
    const amountInMinorUnits = Number.isFinite(parseFloat(rawAmount))
      ? Math.round(parseFloat(rawAmount) * 100).toString()
      : '0';

    
    const baseUserData = [
      { key: 'streamId',   value: streamId },
      { key: 'commandId',  value: commandId },
      { key: 'customerId', value: customerId },
    ].filter(x => x.value != null && x.value !== '');

    let userDataXml = baseUserData
      .map((data, idx) => `<userData${idx + 1}>${data.value}</userData${idx + 1}>`)
      .join('');

    userDataXml += `<userData9>${environment}</userData9>`;
    userDataXml += `<userData10>ticket</userData10>`;

    const ac = new AbortController();

    const fetchPayment = async () => {
      try {
        if (!backendUrl) {
          throw new Error('Missing REACT_APP_BACKEND_URL');
        }

        const res = await fetch(`${backendUrl}/api/qa/get-payment-page`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            amount: amountInMinorUnits,
            customerId,
            env: environment,
            userData: userDataXml,
          }),
          signal: ac.signal,
        });

        if (!res.ok) {
          throw new Error(`Network response was not ok (${res.status})`);
        }

        const data = await res.json();
        if (data?.url) setPaymentUrl(data.url);
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('fetchPayment error:', err);
        }
      }
    };

    fetchPayment();
    return () => ac.abort();
  }, [backendUrl, location.search, params]);

  return paymentUrl ? <IframeComponent src={paymentUrl} /> : <LoadingPage />;
}

export default withLinkValidation(PercallIframe);
